<template>
<div>
	<div class="vx-col w-full mb-base">
		<vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 class="ml-3">Add RDO</h4>
                </div>
                <div class="flex items-center">
                    <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="createDo" v-if="!editMode">Create Delivery Order</vs-button> -->
                    <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editForm">Edit</vs-button> -->
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                    <!-- <vs-button @click="printOdNote" class="btn mb-4 md:mb-0 mr-1" icon="print">Print</vs-button> -->
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Req. Delivery Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.req_del_date"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Client*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                                :disabled="withReference"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Origin*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.origin_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, customer)"
                                @change="setCustomer('origin')"
                                :disabled="withReference"
                            >
                                <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            &nbsp;
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.origin_1" disabled />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            &nbsp;
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.origin_2" disabled />
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Destination*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.destination_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, customer)"
                                @change="setCustomer('destination')"
                                :disabled="withReference"
                            >
                                <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            &nbsp;
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.destination_1" disabled />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            &nbsp;
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.destination_2" disabled />
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            RDO Status
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.rdo_status" :disabled="true" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            DO Reference
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.do_reference" :disabled="true"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Order Type*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.order_type_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, order_type)"
                                :disabled="withReference"
                            >
                                <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Posting Date
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.posting_date"/>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-10">
                <vs-tab label="Item Details">
                    <vs-button @click="addItem()" class="btn mb-5 mr-1 mt-5" :disabled="!data.client_id">Add</vs-button>
                    <div style="overflow-y: auto;">
                        <table cellspacing="5">
                            <thead>
                                <tr>
                                    <th style="width: 1%">Line ID</th>
                                    <th style="width: 10%">Warehouse</th>
                                    <th style="width: 10%">Product</th>
                                    <th style="width: 10%">Description</th>
                                    <th style="width: 5%">Pack ID</th>
                                    <th style="width: 5%">Batch</th>
                                    <th style="width: 10%">Exp. Date</th>
                                    <th style="width: 5%">Qty</th>
                                    <th style="width: 5%">UoM</th>
                                    <th style="width: 10%">Stock Type</th>
                                    <th style="width: 5%">Open Qty</th>
                                    <th style="width: 5%">Base Qty</th>
                                    <th style="width: 5%">Base UoM</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(detail, index) in data.details" :key="index">
                                    <td>
                                        <vs-input class="w-full" v-model="detail.line_id" :disabled="true"/>
                                    </td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.warehouse_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDropdown($event, warehouse)"
                                            :disabled="withReference"
                                        >
                                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                        </vs-select>
                                    </td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.product_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchProductClient($event)"
                                            @change="getProduct(detail)"
                                            :disabled="withReference"
                                        >
                                            <vs-select-item v-for="(item, index) in products" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </td>
                                    <td>
                                        <vs-input class="w-full" v-model="detail.description" :disabled="true"/>
                                    </td>
                                    <td>
                                        <vs-input class="w-full" v-model="detail.pack_id" :disabled="!detail.product_id || withReference"/>
                                    </td>
                                    <td>
                                        <vs-input class="w-full" v-model="detail.batch" :disabled="!detail.product_id || withReference"/>
                                    </td>
                                    <td>
                                        <flat-pickr class="w-full" v-model="detail.expired_date" :disabled="!detail.product_id || withReference"/>
                                    </td>
                                    <td>
                                        <vs-input class="w-full" v-model="detail.qty" @input="convertQty(detail)" :disabled="!detail.product_id"/>
                                    </td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.uom_id"
                                            width="100%"
                                            autocomplete
                                            @change="uomChange(detail)"
                                            :disabled="!detail.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in detail.uoms" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.stock_type_id"
                                            width="100%"
                                            autocomplete
                                            :disabled="!detail.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </td>
                                    <td>
                                        <vs-input class="w-full" v-model="detail.open_qty" :disabled="true"/>
                                    </td>
                                    <td>
                                        <vs-input class="w-full" v-model="detail.base_qty" disabled/>
                                    </td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.base_uom_id"
                                            width="100%"
                                            autocomplete
                                            disabled
                                        >
                                            <vs-select-item v-for="(item, index) in detail.uoms" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </td>
                                    <td>
                                        <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)">Remove</vs-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </vs-tab>
                <vs-tab label="Transport and Unloading"></vs-tab>
                <vs-tab label="Notes"></vs-tab>
                <vs-tab label="Attachment"></vs-tab>
            </vs-tabs>
		</vs-card>
    </div>
</div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import '@/assets/scss/vuesax/_wmsTheme.scss'

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            data: {
                do_id: null,
                reference: '',
                req_del_date: new Date(),
                order_type_id: null,
                posting_date: null,
                origin_id: null,
                origin_1: '',
                origin_2: '',
                destination_id: null,
                destination_1: '',
                destination_2: '',
                client_id: null,
                rdo_status: 'Draft',
                do_reference: '',
                details: [],
                notes: ''
            },
            isLoading: false,
            clientOption: [],
            customerOption: [],
            orderTypeOption: [],
            productOption: [],
            stockTypeOption: [],
            warehouseOption: [],
            withReference: false,
            dataChanged: false,
            old_details: [],
            order_type: {
                data: [],
                loading: false,
                endpoint: 'master/ordertypes',
                objectKey: 'order_type'
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            customer: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            stock_type: {
                data: [],
                loading: false,
                endpoint: 'master/stocktypes',
                objectKey: 'name'
            },
            products: [],
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
    },
    methods: {
        back() {
            if(this.dataChanged) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirmation',
                    text: 'Leave page?',
                    accept: () => {
                        this.$router.push({
                            name: 'return-delivery-order',
                        })
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            }
            else {
                this.$router.push({
                    name: 'return-delivery-order',
                })
            }
        },
        fetchData() {
            this.isLoading = true
            const promises = [
                this.$http.post('master/customers/filter/dropdown'),
                this.$http.post('master/clients/filter/dropdown'),
                this.$http.post('master/ordertypes/filter/dropdown'),
                this.$http.post('master/stocktypes/filter/dropdown'),
            ]

            Promise.all(promises)
            .then(this.$http.spread((customers, clients, ordertypes, stocktypes) => {
                this.clientOption = clients.data
                this.orderTypeOption = ordertypes.data
                this.customerOption = customers.data
                this.stockTypeOption = stocktypes.data

                this.isLoading = false
                this.applyWatcher()
            }))
            .catch(error => {
                console.log(error)
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            })
        },
        fetchReference() {
            this.isLoading = true
            Promise.all([
                this.$http.post('outbound/returndeliveryorder/getdo', { id: this.$route.params.id }),
                this.$http.post('master/stocktypes'),
            ])
            .then(this.$http.spread((res, stocktypes) => {
                this.stock_type.data = stocktypes.data.data

                this.order_type.data.push(res.data.order_type)
                this.customer.data.push(res.data.origin)
                this.customer.data.push(res.data.destination)
                this.client.data.push(res.data.client)

                this.data.do_id = res.data.id
                this.data.do_reference = res.data.do_reference
                this.data.origin_id = res.data.origin_id
                this.data.destination_id = res.data.destination_id
                this.data.client_id = res.data.client_id
                this.data.order_type_id = res.data.order_type_id

                res.data.do_details.map((item, index) => {
                    const uoms = item.product.uoms.map(uom => {
                        return {
                            value: uom.uom_id,
                            label: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                        }
                    })

                    if(this.products.findIndex(p => p.value === item.product.id) === -1) {
                        this.products.push({ value: item.product.id, label: item.product.product_code, description_1: item.product.description_1, description_2: item.product.description_2, base_uom: item.product.base_uom, uoms: uoms })
                    }

                    if(this.warehouse.data.findIndex(w => w.id === item.warehouse.id === -1)) {
                        this.warehouse.data.push(item.warehouse)
                    }

                    this.data.details.push({
                        do_detail_id: item.id,
                        line_id: index + 1,
                        warehouse_id: item.warehouse_id,
                        product_id: item.product_id,
                        description: item.product.description_1,
                        pack_id: item.pack_id,
                        batch: item.batch,
                        expired_date: item.expired_date,
                        qty: item.qty,
                        uom_id: item.uom_id,
                        stock_type_id: item.stock_type_id,
                        open_qty: item.base_qty,
                        base_qty: item.base_qty,
                        base_uom_id: item.base_uom_id,
                        uoms: [],
                        qtyError: false,
                        denominator: 0,
                        numerator: 0,
                        totalQty: item.base_qty
                    })
                })

                this.data.details.map(detail => {
                    this.getProduct(detail)
                })

                this.isLoading = false
            }))
            .catch(error => this.handleError(error))
        },
        applyWatcher() {
            this.$watch('data', function() {
                this.dataChanged = true
            }, { deep: true });
        },
        addItem() {
            if(this.withReference) {
                let id = 0
                this.old_details.map(old => {
                    let exist = false
                    this.data.details.map(current => {
                        if(current.do_detail_id == old.do_detail_id) {
                            exist = true
                        }
                    })

                    if(!exist) {
                        let newItem = JSON.parse(JSON.stringify(old))
                        this.data.details.push(newItem)
                    }
                    else {
                        let totalBaseQty = 0
                        this.data.details.map(item => {
                            if(item.do_detail_id == old.do_detail_id) {
                                totalBaseQty += item.base_qty
                            }
                        })

                        if(totalBaseQty < old.base_qty) {
                            let newItem = JSON.parse(JSON.stringify(old))
                            newItem.base_qty = old.base_qty - totalBaseQty
                            this.data.details.push(newItem)

                            this.data.details.map(item => {
                                if(item.id == newItem.id) {
                                    item.open_qty = 0
                                }
                            })
                        }
                    }
                })

                this.data.details.map(item => {
                    this.onUomChange(item)
                    item.qty = this.setQty(item)
                })

                this.assignLineId()
            }
            else {
                if(this.data.details.length < 1) {
                    this.isLoading = true
                    this.$http.post('master/product/showbyclient', { client_id: this.data.client_id })
                    .then(res => {
                        this.products = []
                        this.isLoading = false

                        res.data.data.map(item => {
                            const uoms = item.uoms.map(uom => {
                                return {
                                    value: uom.uom_id,
                                    label: uom.uom.name,
                                    numerator: uom.numerator,
                                    denominator: uom.denominator,
                                }
                            })
                            this.products.push({ value: item.id, label: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                        })

                        this.data.details.push({
                            line_id: 0,
                            warehouse_id: this.$store.state.user.userconfig.warehouses.id ? this.$store.state.user.userconfig.warehouses.id : null,
                            product_id: null,
                            description: '',
                            pack_id: '',
                            batch: '',
                            expired_date: null,
                            qty: '',
                            uom_id: null,
                            stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                            open_qty: 0,
                            base_qty: 0,
                            base_uom_id: null,
                            uoms: [],
                            qtyError: false,
                            denominator: 0,
                            numerator: 0,
                        })

                        this.assignLineId()
                    })
                    .catch(error => this.handleError(error))
                }
                else {
                    this.data.details.push({
                        line_id: 0,
                        warehouse_id: this.$store.state.user.userconfig.warehouses.id ? this.$store.state.user.userconfig.warehouses.id : null,
                        product_id: null,
                        description: '',
                        pack_id: '',
                        batch: '',
                        expired_date: null,
                        qty: '',
                        uom_id: null,
                        stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                        open_qty: 0,
                        base_qty: 0,
                        base_uom_id: null,
                        uoms: [],
                        qtyError: false,
                        denominator: 0,
                        numerator: 0,
                    })
                }

                this.assignLineId()
            }
        },
        onProductChange(detail) {
            this.productOption.map(item => {
                if(item.value == detail.product_id) {
                    detail.description = item.description
                    detail.uomOption = item.uoms.map(item => {
                        return {
                            value: item.id,
                            text: item.name,
                            numerator: item.numerator,
                            denominator: item.denominator
                        }
                    })

                    if(!this.withReference) {
                        detail.base_uom_id = item.base_uom_id
                        detail.uom_id = item.base_uom_id
                        detail.qty = 1
                    }
                }
            })

            this.onUomChange(detail)
        },
        uomChange(detail) {
            const data = detail.uoms[detail.uoms.findIndex(a => a.value === detail.uom_id)]
            detail.numerator = data.numerator
            detail.denominator = data.denominator

            this.convertQty(detail)
        },
        removeDetail(index) {
            if(this.withReference) {
                this.data.details.map(item => {
                    if(item.do_detail_id == this.data.details[index].do_detail_id) {
                        item.open_qty += this.data.details[index].base_qty
                    }
                })
            }

            this.data.details.splice(index, 1)
            this.assignLineId()
        },
        generateLineId(){
            return this.data.details.length + 1
        },
        assignLineId() {
            this.data.details.map((item, index) => {
                item.line_id = index + 1
            })
        },
        convertQty(detail){
            detail.open_qty = detail.base
            detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
            if(this.withReference) {
                detail.open_qty = detail.totalQty - detail.base_qty
                // let open_qty = 0

                // this.data.details.map(item => {
                //     open_qty += item.base_qty
                // })

                // this.data.details.map(item => {
                //     if(detail.do_detail_id == item.do_detail_id) {
                //         item.open_qty = item.maxqty - open_qty
                //     }
                // })
            }
            else {
                detail.open_qty = detail.base_qty
            }
        },
        setQty(item) {
			return (item.base_qty * item.denominator) / item.numerator
        },
        submitForm() {
            let error = false
            const details = []

            this.data.details.map(item => {
                details.push({
                    do_detail_id: item.do_detail_id ? item.do_detail_id : null,
                    line_id: item.line_id,
                    warehouse_id: item.warehouse_id,
                    product_id: item.product_id,
                    pack_id: item.pack_id,
                    batch: item.batch,
                    expired_date: item.expired_date,
                    qty: item.qty,
                    uom_id: item.uom_id,
                    stock_type_id: item.stock_type_id
                })
            })

            const data = {
                do_id: this.data.do_id,
                reference: this.data.reference,
                req_del_date: this.data.req_del_date,
                order_type_id: this.data.order_type_id,
                posting_date: this.data.posting_date,
                origin_id: this.data.origin_id,
                destination_id: this.data.destination_id,
                client_id: this.data.client_id,
                details: details,
                notes: this.data.notes
            }

            if(error) {
                return false
            }

            this.isLoading = true
            this.$http.post('outbound/returndeliveryorder/store', data)
            .then(res => {
                this.isLoading = false
                const message = res.data.message ? res.data.message : 'Success'
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: message
                })
                this.$router.push({
                    name: 'return-delivery-order-view',
                    params: {
                        id: res.data.rdo_id
                    }
                })
            })
            .catch(error => this.handleError(error))
        },
        getDropdowns() {
            this.isLoading = true
            return Promise.all([
                this.$http.post('master/clients'),
                this.$http.post('master/ordertypes'),
                this.$http.post('master/customers'),
                this.$http.post('master/warehouses'),
                this.$http.post('master/stocktypes'),
            ])
            .then(this.$http.spread((clients, ordertypes, customers, warehouses, stocktypes) => {
                this.client.data = clients.data.data
                this.order_type.data = ordertypes.data.data
                this.customer.data = customers.data.data
                this.warehouse.data = warehouses.data.data
                this.stock_type.data = stocktypes.data.data
                this.isLoading = false
            }))
            .catch(error => this.handleError(error))
        },
        setCustomer(val) {
            if(val == 'origin') {
                const index = this.customer.data.findIndex(c => c.id == this.data.origin_id)
                if(index !== -1) {
                    this.data.origin_1 = this.customer.data[index].address_1
                    this.data.origin_2 = this.customer.data[index].address_2
                }
            }
            else if(val == 'destination') {
                const index = this.customer.data.findIndex(c => c.id == this.data.destination_id)
                if(index !== -1) {
                    this.data.destination_1 = this.customer.data[index].address_1
                    this.data.destination_2 = this.customer.data[index].address_2
                }
            }
        },
        getProduct(detail) {
            const data = this.products[this.products.findIndex(a => a.value === detail.product_id)]
            detail.description = data.description_1
            detail.uom_id = data.base_uom.uom_id
            detail.base_uom_id = data.base_uom.uom_id
            detail.uoms = data.uoms

            const uom = detail.uoms[detail.uoms.findIndex(a => a.value === detail.uom_id)]
            detail.numerator = uom.numerator
            detail.denominator = uom.denominator
            
            if(!this.withReference) {
                detail.base_qty = 1
                detail.qty = 1
            }
        },
        searchProductClient(e) {
            this.$http.post('master/product/showbyclient', { client_id: this.data.client_id })
            .then(res => {
                res.data.data.map(item => {
                    const uoms = item.uoms.map(uom => {
                        return {
                            value: uom.uom_id,
                            label: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                        }
                    })

                    if(this.products.findIndex(p => p.value === item.id) === -1) {
                        this.products.push({ value: item.id, label: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                    }
                })
            })
        },
    },
    mounted() {
        if(this.$route.params.withReference) {
            this.withReference = true
            this.fetchReference()
        }
        else {
            this.data.client_id = this.$store.state.user.userconfig.clients.id
            this.data.origin_id = this.$store.state.user.userconfig.origin.id
            this.data.origin_1 = this.$store.state.user.userconfig.origin.address_1
            this.data.origin_2 = this.$store.state.user.userconfig.origin.address_2
            this.data.destination_id = this.$store.state.user.userconfig.destination.id
            this.data.destination_1 = this.$store.state.user.userconfig.destination.address_1
            this.data.destination_2 = this.$store.state.user.userconfig.destination.address_2
            this.data.order_type_id = this.$store.state.user.userconfig.inbount_type.id
            this.getDropdowns()
        }

        this.dataChanged = false
    },
}

</script>